module.exports = __webpack_public_path__ + "static/media/Wakeboarding.c9fc1151.jpg";